import { LONELINESS_OPTIONS } from '../LONELINESS_OPTIONS';
import { LonelinessOptionIdType } from '../types';

const DEFAULT: LonelinessOptionIdType = 'sometimes';

export const getLonelinessIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): LonelinessOptionIdType | null => {
  const id = LONELINESS_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
